<mat-dialog-content [ngClass]="{'showing-hints':showing_hints}">
  <mat-tab-group [disableRipple]="true">
    <mat-tab label="Properties">
      <form class="form-section column space-between">
        <div class="column">
          @if (!efc.component_data.hasOwnProperty('id') || efc.addEquipmentType=='existing') {
            <div class="row">
              <mat-form-field>
                <mat-label>Select to add new or existing equipment</mat-label>
                <mat-select [(ngModel)]="efc.addEquipmentType"
                  (selectionChange)="efc.resetEquipment()"
                  name="add_equipment_type"
                  placeholder="New or existing equipment">
                  <mat-option value="new">New</mat-option>
                  <mat-option value="existing">Existing</mat-option>
                </mat-select>
              </mat-form-field>
              @if ((component.hasOwnProperty('id') && efc.addEquipmentType!=='existing') || efc.addEquipmentType=='new') {
                <mat-form-field
                  (mouseenter)="hint='Icon'"
                  >
                  <mat-label style="display:flex;align-items:center;">
                    Select an Icon <img height="30px" src="{{ efc.component_data.attributes.icon }}" width="30px"/>
                  </mat-label>
                  <!--<label>Select Icon<img src="{{ efc.component_data.attributes.icon }}" width="30px" height="30px"/></label>-->
                  <mat-select [(ngModel)]="efc.component_data.attributes.icon" name="equipment_icon">
                    @for (img of efc.images; track img) {
                      <mat-option [value]="img" class="image-options">
                        <img height="30px" src="{{ img }}" width="30px"/><span>{{ img.split("/")[4].split('.')[0] }}</span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (efc.addEquipmentType=='existing') {
                <div style="width:50%;">
                  <select-search-component
                    [custom_filters]="efc.custom_equipment_filters"
                    (selectionChange)="efc.existing_component=$event.value;efc.selectExisting()"
                    [api_model]="'equipment'"
                    [value]="efc.existing_component"
                    [classes]="'fill'"
                    [label]="'Select equipment'">
                  </select-search-component>
                </div>
              }
            </div>
          }

          @if ((efc.component_data.hasOwnProperty('id') && efc.addEquipmentType!=='existing')
            || efc.addEquipmentType=='new') {
            <div class="row">
              <mat-form-field (mouseenter)="hint='Name'" style="flex-basis:50%;flex-grow:0;">
                <label>Name</label>
                <input [(ngModel)]="efc.component_data.attributes.name" matInput name="name" placeholder="">
              </mat-form-field>
              <mat-form-field (mouseenter)="hint='Description'" style="flex-basis:50%;flex-grow:0;">
                <label>Description</label>
                <input [(ngModel)]="efc.component_data.attributes.description" matInput name="description" placeholder="">
              </mat-form-field>
              <div class="tip-box" style="flex-grow:1;">
                <div [ngClass]="{'showing': hint=='Name'}" class="tip">
                  <label>Name</label>
                  <div>
                    The name of the equipment.
                  </div>
                </div>
                <div [ngClass]="{'showing': hint=='Description'}" class="tip">
                  <label>Description</label>
                  <div>
                    A more lengthy description of the equipment.
                  </div>
                </div>
              </div>
            </div>
          }

        </div>
      </form>
    </mat-tab>

    @if (efc.component_data.hasOwnProperty('id')) {
      <mat-tab label="Relationships">
        <form class="form-section column space-between">
          <div class="column">
            <div class="row">
              <mat-form-field>
                <mat-label>Parent component</mat-label>
                <mat-select
                  (selectionChange)="efc.moveEquipment(chart_component.parent_component.data.attributes?.base_type);"
                  [(ngModel)]="efc.selected_parent" [compareWith]="efc.matSelectCompare"
                  [disabled]="true"
                  name="selected_parent">
                  @for (parent of efc.parent_list; track parent) {
                    <mat-option
                    [value]="parent">{{parent.attributes.name}} - {{parent.attributes.description}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field (mouseenter)="hint='EquipmentType'" style="flex-basis:50%;flex-grow:0;">
                <mat-label>Equipment Type</mat-label>
                <mat-select
                  (selectionChange)="efc.fillConstantTemplate(efc.component_data.relationships.component_type.data)"
                  [(ngModel)]="efc.component_data.relationships.component_type.data"
                  [compareWith]="efc.matSelectCompare"
                  name="equipment_type">
                  @for (component_type of efc.component_types; track component_type) {
                    <mat-option [value]="component_type">
                    {{component_type.attributes.name}} - {{component_type.attributes.description}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="tip-box" style="flex-grow:1;">
                <div [ngClass]="{'showing': hint=='EquipmentType'}" class="tip">
                  <label>Equipment Type</label>
                  <div>
                    This will be used to identify the template of series types that are applicable for this equipment.
                    After creating the equipment, the 'Fill series template' button can be used to
                    add these series types to this equipment.
                  </div>
                </div>
                <div [ngClass]="{'showing': hint=='FillSeriesTemplate'}" class="tip">
                  <label>Fill Series Template</label>
                  <div>
                    This will be used to identify the template of series types that are applicable for this equipment.
                    After creating the equipment, the 'Fill series template' button can be used to
                    add these series types to this equipment.
                  </div>
                </div>
              </div>
            </div>
            <ng-container>
              <h4>Custom Properties</h4>
              <component-constant-table [constant_property_dict]="efc.constant_property_dict"
                [component]="efc.component_data"
                [component_constants]="efc.constant_components"
                [flowchart]="efc.chart"
                class="row">
              </component-constant-table>
            </ng-container>
            <h4>Series</h4>
            <div class="row end">
              <select-many-search [(value)]="efc.selected_series"
                [classes]="'fill'"
                [data]="efc.plantData.all_series"
                [fill_stubs]="true"
                [label]="'Select a series'"
                class="select-search"              >
              </select-many-search>
              <div class="row end">
                <button (click)='efc.addSeries()' class="icon" matTooltip="Add to equipment">
                  <i class="fa fa-arrow-down"></i></button>
                  <button (click)="efc.showSeriesForm()" class="icon-new" matTooltip="Add new series">
                  </button>
                  <!--<button class="btn" (click)="efc.setTemplate()" matTooltip="Set Template"><i class="fa fa-tasks" ></i></button>-->
                </div>
                <!--<div class="hint">-->
                <!--Select a series and use the Add to process button to add it to this process. The Add new series button can be used to create a new series which will be added to this process.-->
              <!--</div>-->
            </div>
            @if (efc.component_data) {
              <series-component-table
                [all_series]="efc.plantData.all_series"
                [component]="efc.component_data"
                [deleted_component_ids]="efc.deleted_component_ids"
                [flowchart]="efc.chart"
                class="row">
              </series-component-table>
            }
            @if (efc.series_permissions) {
              <h4 style="margin-top:20px;">Constant Series Data </h4>
            }
            <!--<div class="hint" ng-if="$parent.$parent.showHints && show_constants">-->
            <!--Manage constant values for a series in the form(s) below. Use the 'Add new' button to add a new constant value for a series. To remove an entry, delete the value at the required date-time. Use the 'Save' button to save all changes.-->
          <!--</div>-->
          @if (efc.series_permissions) {
            @for (series_component of efc.series_components; track series_component) {
              <div
                style="min-width:650px;">
                @if (series_component.relationships.series.data && (
                  series_component.relationships.series.data.attributes.fill_method=='Constant'
                  || series_component.relationships.series.data.attributes.fill_method=='Constant Monthly Flatten')
                  && efc.series_permissions[series_component.relationships.series.data.id]
                  && efc.series_permissions[series_component.relationships.series.data.id].indexOf('view_process_data') > -1) {
                  <div class="row">
                    <label
                      (click)="series_component.relationships.series.data.hide_constants=!series_component.relationships.series.data.hide_constants"
                      style="color:gray; text-decoration: underline;padding-top:20px;cursor:pointer;">
                      {{series_component.relationships.series.data.attributes.name}}
                      <i [ngClass]="{'fa-angle-up': !series_component.relationships.series.data.hide_constants, 'fa-angle-down': series_component.relationships.series.data.hide_constants}"
                        aria-label="Hide data values"
                        class="fa fa-angle-up"
                        matTooltip="Hide data values" role="button" style="border:none; margin-left:12px;" tabindex="0">
                      </i></label>
                    </div>
                    @if (!series_component.relationships.series.data.hide_constants) {
                      <constant-series-data
                        [series]="series_component.relationships.series.data"
                        [series_permissions]="efc.series_permissions">
                      </constant-series-data>
                    }
                  }
                </div>
              }
            }
          </div>
        </form>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>

<div class="action-buttons">
  @if (dialog) {
    <button (click)="close()" class="btn-close">Close</button>
  }
  <button (click)="save()" class="btn-save" style="margin-right:10px;">Save</button>
</div>
